(() => {
  const copyButtons = document.querySelectorAll('[data-rpg-copy-email]');

  const fallbackCopy = (value) => {
    const textarea = document.createElement('textarea');
    textarea.value = value;
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';
    document.body.appendChild(textarea);
    textarea.select();

    const copied = document.execCommand('copy');
    textarea.remove();
    return copied;
  };

  copyButtons.forEach((button) => {
    button.addEventListener('click', async () => {
      const email = button.dataset.rpgCopyEmail;
      const label = button.querySelector('[data-rpg-copy-email-label]');
      if (!email || !label) return;

      try {
        if (navigator.clipboard && window.isSecureContext) {
          await navigator.clipboard.writeText(email);
        } else if (!fallbackCopy(email)) {
          throw new Error('Copy command was unavailable.');
        }

        label.textContent = 'Copied email';
      } catch (error) {
        label.textContent = email;
      }
    });
  });
})();
